// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f54f86d6","477":"3494e956","877":"9c8eda76"}[chunkId] + ".chunk.js";
};